<template>
    <DForm @submit.prevent="submitForm">
        <DCardBody>
            <DButton
                icon="map-legend"
                :label="__('settings.dunning_pdf_settings.legend')"
                class="mb-3"
                @click="showLegend = !showLegend"
            />
            <DCollapse v-show="showLegend">
                <DTable
                    v-show="showLegend"
                    :items="placeholders"
                    :fields="[
                        {key: 'placeholder', label: __('settings.dunning_pdf_settings.available_placeholders')},
                        {key: 'description', label: __('settings.dunning_pdf_settings.description')},
                    ]"
                />
            </DCollapse>
            <br>
            <DButton
                icon="cog-outline"
                :label="__('tools.emails.placeholder_groups.help_on_template_logic')"
                class="mb-3"
                @click="showHelpOnTemplateLogic = !showHelpOnTemplateLogic"
            />
            <DCollapse v-show="showHelpOnTemplateLogic">
                <HelpTemplateDocs :documentations="documentation" />
            </DCollapse>
            <DFormRow
                :label="__('customers.customers.brand') "
                :error="errors['dunning_pdf_setting_brand_id']"
                is-vertical
                is-required
                :hint="__('customers.customers.brand_hint')"
            >
                <DSelect
                    id="brand"
                    v-model="form.dunning_pdf_setting_brand_id"
                    :options="brands"
                    :placeholder="__('customers.customers.brand')"
                    :disabled="editPage === true"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.dunning_pdf_settings.form.language')"
                :error="errors['language_code']"
                is-vertical
                is-required
                :hint="__('settings.dunning_pdf_settings.form.language_hint')"
            >
                <DSelect
                    v-model="form.language_code"
                    :options="allLanguages"
                    :disabled="editPage === true"
                />
            </DFormRow>
            <DRow
                v-for="(configuration, index) in configurations"
                :key="index"
                class="mb-3"
            >
                <DCol col="12">
                    <h2 class="h5">
                        {{ __(`settings.dunning_pdf_settings.types.${configuration.dunning_letter_type}`) }}
                        <label
                            v-if="isValid(index, 'dunning_letter_type') === false"
                            class="text-danger"
                        >
                            <small>{{ invalidFeedback(index, 'dunning_letter_type') }}</small>
                        </label>
                    </h2>
                </DCol>
                <DCol col="12">
                    <DFormTextarea
                        :id="`description_${index}`"
                        v-model="form.dunningPdfSettingsData[index].description"
                        rows="5"
                        :label="__('settings.dunning_pdf_settings.form.description')"
                        :is-valid="isValid(index, 'description')"
                        :invalid-feedback="invalidFeedback(index, 'description')"
                    />
                </DCol>
                <DCol
                    col="12"
                    class="mt-2"
                >
                    <DInput
                        :id="`headline_${index}`"
                        v-model="form.dunningPdfSettingsData[index].headline"
                        :label="__('settings.dunning_pdf_settings.form.headline')"
                        :is-valid="isValid(index, 'headline')"
                        :invalid-feedback="invalidFeedback(index, 'headline')"
                        maxlength="255"
                    />
                </DCol>
            </DRow>
            <DFormControls
                :dirty="form.isDirty"
                @submit="submitForm"
            />
        </DCardBody>
    </DForm>
</template>

<script>

import HelpTemplateDocs from '~@/Components/Common/Settings/HelpTemplateDocs.vue'
import documentDocs from '~@/Mixins/documentDocs'

export default {
    name: 'InvoicePdfSettingForm',
    components: { HelpTemplateDocs },
    mixins: [documentDocs],
    props: {
        editPage: {
            type: Boolean,
            default: () => { return true }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        configurations: {
            type: Array,
            default: () => { return [] }
        },
        placeholders: {
            type: Array,
            default: () => { return [] }
        },
        brands: {
            type: Array,
            default: () => { return [] }
        },
        allLanguages: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['DunningPdfSettingFormSubmit'],
    data () {
        return {
            form: null,
            dunningPdfSettingsData: [],
            showLegend: false,
            showHelpOnTemplateLogic: false
        }
    },
    computed: {
        documentation () {
            return documentDocs
        }
    },
    created () {
        this.configurations.forEach((configuration) => {
            this.dunningPdfSettingsData.push({
                dunning_pdf_setting_id: configuration.id,
                dunning_letter_type: configuration.dunning_letter_type,
                description: configuration.description,
                headline: configuration.headline
            })
        })
        this.form = this.$inertia.form({
            dunning_pdf_setting_brand_id: this.configurations[0]?.brand_id ?? '',
            dunningPdfSettingsData: this.dunningPdfSettingsData,
            language_code: this.configurations[0]?.language_code ?? null
        })
    },
    methods: {
        submitForm () {
            this.$emit('DunningPdfSettingFormSubmit', this.form)
        },
        isValid (index, field) {
            if (typeof this.errors[`dunningPdfSettingsData.${index}.${field}`] !== 'undefined') {
                return false
            }

            return null
        },
        invalidFeedback (index, field) {
            if (this.isValid(index, field) === false) {
                return this.errors[`dunningPdfSettingsData.${index}.${field}`]
            }

            return null
        }
    }
}
</script>
